import { type Configuration, LimitsApi } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/limits';

export const limits = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const limitsApi = new LimitsApi(config);
  return {
    useProjectMaxRetentionDays: () =>
      httpClient.execute(
        limitsApi.getProjectMaxRetentionDaysLimit.bind(limitsApi),
        baseUrl,
        '/retention-days',
        currentProjectId
      ),
    useBlockedPolicyTypes: () =>
      httpClient.execute(
        limitsApi.getBlockedPolicyTypes.bind(limitsApi),
        baseUrl,
        '/blocked-policy-types',
        currentProjectId
      ),
  };
};
